module.exports = __webpack_public_path__ + "static/zm-53783063b6ae78cd142f0763a2a846cf.svg";